import { Instance, types } from 'mobx-state-tree';

import AlbumModel, { IAlbumModel } from './AlbumModel';
import TrackModel, { ITrackModel } from './TrackModel';

const SearchModel = types
    .model('SearchModel', {
        id: types.identifier,
        tracks: types.optional(types.array(types.reference(TrackModel)), []),
        albums: types.optional(types.map(types.reference(AlbumModel)), {}),
    })
    .actions(self => {
        const addTrack = (track: ITrackModel) => {
            self.tracks.push(track);
        };

        const addAlbum = (album: IAlbumModel) => {
            self.albums.set(album.id, album);
        };
        return { addTrack, addAlbum };
    });

export interface ISearchModel extends Instance<typeof SearchModel> {}

export default SearchModel;
